const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时全天候追踪娱乐圈最新动态，黑料事件第一时间推送，不错过任何重磅爆料，确保用户始终掌握最前沿的吃瓜资讯。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '独家资源',
    desc: '汇聚全网独家91黑料资源，覆盖明星八卦、网红翻车、行业揭秘等多维度内容，为用户提供最全面的黑料吃瓜体验。',
  },
  {
    icon: 'ri-group-line',
    title: '互动社区',
    desc: '庞大的吃瓜群众社区，用户可以自由交流讨论最新黑料事件，分享独家线索与观点，打造最有氛围的黑料交流平台。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            91黑料网致力于打造最专业的黑料吃瓜平台，以下是我们的核心优势
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item) => (
            <div
              key={item.title}
              className="group p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}